import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getStoredUser, getToken } from "@/lib/auth";

/**
 * Route-level role gate: requires authenticated staff or admin accounts.
 *
 * Unauthenticated visitors are redirected to /login.
 * Surveyors (who are not permitted to manage accounts) are redirected to / (Projects page).
 */
export default function RequireStaff({ children }: { children: ReactNode }) {
  if (!getToken()) {
    return <Navigate to="/login" replace />;
  }

  const user = getStoredUser();
  if (user?.role === "surveyor") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
